import {
  Flex,
  IconButton,
  IconEditLine,
  IconTrashLine,
  Text,
} from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { PlanTemplateService } from "../../services/PlanTemplateService";
import { Card } from "../Card";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import { DialogYesNo } from "../DialogYesNo";

const TemplateCard = ({ template, setTemplates, setSelectedTemplate }) => {
  const showNotification = useNotification();
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDelete = async () => {
    await PlanTemplateService.deleteTemplate(template.id)
      .then(() => {
        setTemplates((prevTemplates) =>
          prevTemplates.filter((t) => t.id !== template.id)
        );
        setDeleteModal(false);
        showNotification(
          t("notifications.general.deleteSuccess", { obj: "Template" })
        );
      })
      .catch(() =>
        showNotification(
          t("notifications.general.deleteError", { obj: "Template" }),
          ERROR
        )
      );
  };

  return (
    <Card
      style={{
        color: "#0D323F",
        backgroundColor: "#F2F8FA",
        border: "1px solid #ccc",
        borderRadius: 10,
        padding: "10px 15px",
        marginBottom: 15,
      }}
    >
      <Flex>
        <Flex.Item shouldGrow shouldShrink>
          <Text weight="bold">{template.name}</Text>
        </Flex.Item>
        <Flex.Item margin="0 small 0 0">
          <IconButton
            renderIcon={IconEditLine}
            screenReaderLabel={t("templates.editTemplate")}
            size="small"
            onClick={() => setSelectedTemplate(template)}
          />
        </Flex.Item>
        <Flex.Item>
          <IconButton
            renderIcon={IconTrashLine}
            screenReaderLabel={t("templates.deleteTemplate")}
            size="small"
            onClick={() => setDeleteModal(true)}
          />
        </Flex.Item>
      </Flex>
      <DialogYesNo
        message={t("templates.deleteConfirm")}
        openStatus={deleteModal}
        onClickNo={() => setDeleteModal(false)}
        onClickYes={handleDelete}
      />
    </Card>
  );
};

export default TemplateCard;
